module.exports = __webpack_public_path__ + "media/images/lp_v6_img21-752380c1a7b3040d8e9a9efe9425a483.webp";